'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UISliderTrackSegment = exports.getTrackColorFromProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _Props = require('../../utils/Props');

var _Style = require('../../core/Style');

var _Styles = require('../../utils/Styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// avoid setting props w/ same names as valid HTML attributes (like `width`) on div
var CleanDiv = (0, _Props.omitProps)(function (props) {
  return _react2.default.createElement('div', props);
}, ['left', 'lineStyle', 'width', 'color', 'restricted', 'disabled']);

var getTrackColorFromProps = exports.getTrackColorFromProps = function getTrackColorFromProps(props) {
  var value = props.value,
      disabled = props.disabled,
      restricted = props.restricted,
      readOnly = props.readOnly;

  if (value <= 0) {
    if (disabled || readOnly) {
      return _colors.KOALA;
    }
    if (!restricted) {
      return _colors.CALYPSO;
    }
  }
  return _colors.BATTLESHIP;
};

var BORDER_WIDTH_BY_SIZE = {
  medium: 1,
  large: 2
};

var getBorderWidthForSize = function getBorderWidthForSize(size) {
  return BORDER_WIDTH_BY_SIZE[size] || 0;
};

var UISliderTrackLine = (0, _styledComponents2.default)(CleanDiv).withConfig({
  displayName: 'UISliderTrack__UISliderTrackLine'
})(['border-color:', ';border-style:', ';border-width:', ';margin:0 ', ';'], function (props) {
  return props.color;
}, function (props) {
  return props.lineStyle;
}, function (props) {
  return (0, _Style.remCalc)(getBorderWidthForSize(props.size));
}, function (props) {
  return (0, _Style.remCalc)(getBorderWidthForSize(props.size));
});
UISliderTrackLine.propTypes = {
  color: _react.PropTypes.string,
  lineStyle: _react.PropTypes.oneOf(['solid', 'dashed']),
  size: _react.PropTypes.oneOf(['medium', 'large'])
};

var UISliderTrackContainer = (0, _styledComponents2.default)(CleanDiv).withConfig({
  displayName: 'UISliderTrack__UISliderTrackContainer'
})(['position:absolute;top:0;bottom:0;left:', ';width:', ';cursor:', ';& ', '{position:absolute;top:', ';right:0;left:0;}'], function (props) {
  return (0, _Styles.toPercent)(props.left);
}, function (props) {
  return (0, _Styles.toPercent)(props.width);
}, function (props) {
  return props.restricted || props.disabled ? 'not-allowed' : undefined;
}, UISliderTrackLine, function (props) {
  return (0, _Style.remCalc)(props.size === 'large' ? 8 : 6);
});

UISliderTrackContainer.propTypes = {
  left: _react.PropTypes.number,
  width: _react.PropTypes.number,
  size: _react.PropTypes.oneOf(['medium', 'large']),
  disabled: _react.PropTypes.bool,
  restricted: _react.PropTypes.bool,
  readOnly: _react.PropTypes.bool
};

var UISliderTrackSegment = exports.UISliderTrackSegment = function UISliderTrackSegment(props) {
  var size = props.size,
      restricted = props.restricted,
      disabled = props.disabled,
      readOnly = props.readOnly,
      left = props.left,
      width = props.width,
      rest = _objectWithoutProperties(props, ['size', 'restricted', 'disabled', 'readOnly', 'left', 'width']);

  var color = getTrackColorFromProps(props);
  var lineStyle = props.restricted ? 'dashed' : 'solid';
  return _react2.default.createElement(
    UISliderTrackContainer,
    _extends({
      size: size,
      left: left,
      width: width,
      disabled: disabled,
      readOnly: readOnly,
      restricted: restricted
    }, rest),
    _react2.default.createElement(UISliderTrackLine, { size: size, color: color, lineStyle: lineStyle })
  );
};
UISliderTrackSegment.propTypes = _extends({}, UISliderTrackContainer.propTypes, {
  value: _react.PropTypes.oneOf([-1, 0, 1])
});
UISliderTrackSegment.defaultProps = {
  value: 0,
  size: 'medium',
  disabled: false,
  restricted: false
};

UISliderTrackSegment.displayName = 'UISliderTrackSegment';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/input/internal/UISliderTrack.js
// module id = 665
// module chunks = 3 4